<template>
  <v-container>
    <p>Redirecting . . .</p>
  </v-container>
</template>

<script>

export default {
  mounted: function () {
    this.$auth.logout({ makeRequest: true })
  }
}
</script>
